<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
  <div class="loading_container" v-else-if="has_profile">
    <div class="alert alert-success m-5 text-center">
      <strong> Você já se cadastrou na Virtap!<br /></strong>
      Redirecionando automaticamente para seu perfil...
    </div>
  </div>
</template>

<script>
import ClientManager from "../../../js/services/client.js";
import StringUtils from "../../../js/utils/string.js";
import Config from "../../../../resources/config.js";

export default {
  components: {},

  created() {
    this.loadClientData();
  },

  data() {
    return {
      has_profile: false,
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },
  },

  methods: {
    async loadClientData() {
      this.$store.commit("setLoading", true);
 
      try {
        let clientData = await ClientManager.getClientSignupData();
        if (!clientData.logged_in) {
          location.href = Config.signupPage;
        } else if (clientData.has_profile) {
          this.$store.commit("setLoading", false);
          this.has_profile = true;
          this.$nextTick(() => {
            setTimeout(() => {
              location.href = "/";
            }, 3000);
          });
        } else {
          location.href = Config.profilePage + "?nome=" + clientData.name;
        }
      } catch (error) {
        this.handleAPIError(error, null);
      }
    },
  },
};
</script>
